import * as React from 'react';
import { SettingPane } from '../../molecules/mypage/page';
import { HomeLocationSummary } from '../home_locations/HomeLocationSummary';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { observer } from 'mobx-react';
import { LoaderRow } from '../../atoms/layout/LoaderRow';
import './homeLocationPane.module.scss';
import { V3Routes } from '../../../routes';
import { LinkButton } from '@sheinc/shelikes-design-system';

const Content = ({ homeLocation }) => {
  if (homeLocation.loading) {
    return <LoaderRow />;
  }
  return (
    <div>
      <HomeLocationSummary userHomeLocation={homeLocation.get()} />
      <div styleName="button-wrapper">
        <LinkButton to={V3Routes.homeLocationUpdate()} fullWidth={GlobalStatesV3.viewport.isSp}>
          拠点を変更する
        </LinkButton>
      </div>
    </div>
  );
};

export const HomeLocationPane = observer(
  class HomeLocationPane extends React.Component {
    render() {
      const { homeLocation } = GlobalStatesV3.currentUser.homeLocation;
      return (
        <SettingPane activeMenu="home_location" title="ホーム拠点の確認/変更">
          <Content homeLocation={homeLocation} />
        </SettingPane>
      );
    }
  }
);
